import { atom } from 'jotai';

import { BusinessStatusType, EmployeeType, SurveyStatusType } from '@/lib/types/survey';

export const refundHistoryIdAtom = atom('');
export const imputedYearAtom = atom('');
export const surveyStatusAtom = atom<SurveyStatusType>({
  surveyAnswerId: '',
  totalAmount: 0,
  taxpayerName: '',
  isCompleted: false,
  deductionTypes: [],
  expiredAt: ''
});
export const surveyAnswerIdAtom = atom((get) => get(surveyStatusAtom).surveyAnswerId);

// Employment
export const employeesAtom = atom<EmployeeType[]>([]);
export const hasEmployeeAtom = atom((get) => get(employeesAtom).length > 0);

export const someCompletedBusinessSurveyAtom = atom(false);

export const businessesAtom = atom<BusinessStatusType[]>([]);
export const currentBusinessBmanTinAtom = atom('');
